function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Component, memo } from 'react';
import DebugBoundary from '../public/DebugBoundary';
import useAnalytics from '../public/useAnalytics';
import useMetrics from '../public/useMetrics';
import useObservabilityConfig from '../public/useObservabilityConfig';
import useProject from '../public/useProject';
import useReports from '../public/useReports';
class InnerErrorBoundary extends Component {
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        var _errorInfo_componentStack, _error_stack;
        const { component, onError, analyticsTrack, metricIncrement, project, reportError, service, uuid } = this.props;
        // Suffix with SAILROOT at the end, so that the composition order is clear
        // (from the outermost to the innermost boundary).
        const fullUuid = `${uuid}-SAILROOT`;
        reportError(`ErrorBoundary error '${error.message}'`, {
            tags: {
                errorBoundaryUuid: fullUuid
            },
            extras: {
                service,
                project,
                component,
                uuid: fullUuid,
                // Extra data in sentry is capped and component stack and js stack can be very big.
                // More info: https://develop.sentry.dev/sdk/data-handling/#variable-size.
                componentStack: (_errorInfo_componentStack = errorInfo.componentStack) === null || _errorInfo_componentStack === void 0 ? void 0 : _errorInfo_componentStack.trim().substring(0, 500),
                jsStack: (_error_stack = error.stack) === null || _error_stack === void 0 ? void 0 : _error_stack.trim().substring(0, 500)
            }
        });
        // For Splunk.
        analyticsTrack('frontend.observability.error_boundary', {
            service,
            project,
            component,
            uuid: fullUuid
        });
        // For Grafana.
        metricIncrement('frontend.observability.error_boundary', {
            service,
            project,
            component,
            uuid: fullUuid
        });
        onError === null || onError === void 0 ? void 0 : onError(error, errorInfo);
    }
    render() {
        const { children, project } = this.props;
        const { error } = this.state;
        const { errorView: ErrorView } = this.props;
        const view = error ? /*#__PURE__*/ _jsx(ErrorView, {
            error: error
        }) : children;
        return /*#__PURE__*/ _jsx(DebugBoundary, {
            category: "ErrorBoundary",
            name: project,
            color: "#B3093C",
            children: view
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "state", {
            error: null
        });
    }
}
/**
 * @see https://sail.stripe.me/apis/observability/ErrorBoundary
 * @see https://sail.stripe.me/apis/observability/ObservabilityProvider
 */ export default /*#__PURE__*/ memo(function ErrorBoundary(props) {
    var _useObservabilityConfig;
    return /*#__PURE__*/ _jsx(InnerErrorBoundary, _object_spread({
        analyticsTrack: useAnalytics().track,
        metricIncrement: useMetrics().increment,
        project: useProject(),
        reportError: useReports().error,
        service: (_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service
    }, props));
});

//# sourceMappingURL=ErrorBoundary.js.map